"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_SUGGESTED_ACTIONS = void 0;
exports["default"] = clearSuggestedActions;
var CLEAR_SUGGESTED_ACTIONS = 'WEB_CHAT/CLEAR_SUGGESTED_ACTIONS';
exports.CLEAR_SUGGESTED_ACTIONS = CLEAR_SUGGESTED_ACTIONS;

function clearSuggestedActions() {
  return {
    type: CLEAR_SUGGESTED_ACTIONS
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJDTEVBUl9TVUdHRVNURURfQUNUSU9OUyIsImNsZWFyU3VnZ2VzdGVkQWN0aW9ucyIsInR5cGUiXSwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvYWN0aW9ucy9jbGVhclN1Z2dlc3RlZEFjdGlvbnMuanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgQ0xFQVJfU1VHR0VTVEVEX0FDVElPTlMgPSAnV0VCX0NIQVQvQ0xFQVJfU1VHR0VTVEVEX0FDVElPTlMnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBjbGVhclN1Z2dlc3RlZEFjdGlvbnMoKSB7XG4gIHJldHVybiB7XG4gICAgdHlwZTogQ0xFQVJfU1VHR0VTVEVEX0FDVElPTlNcbiAgfTtcbn1cblxuZXhwb3J0IHsgQ0xFQVJfU1VHR0VTVEVEX0FDVElPTlMgfTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBLElBQU1BLHVCQUF1QixHQUFHLGtDQUFoQzs7O0FBRWUsU0FBU0MscUJBQVQsR0FBaUM7RUFDOUMsT0FBTztJQUNMQyxJQUFJLEVBQUVGO0VBREQsQ0FBUDtBQUdEIn0=